export default "/_next/static/images/photo-banner-desktop-b68af45f7b77f0fb5877b3e5b51ff855.png";